import styles from "./Referencial.module.css";
import imagem from "../../Imgs/Referencia.png";
import {Link} from 'react-router-dom'
function Referencial() {
  return (
    <div className={styles.container}>
      <h3 id="referencias">//Referencial</h3>
      <div className={styles.conteudo}>
        <img src={imagem}></img>
        <p>
          Por meio de ações de ensino o grupo busca a partir de leituras,
          debates e diálogos com professores em formação, analisar as
          possibilidades e os limites da inserção dos jogos digitais e
          analógicos no ensino de Geografia. Nesse contexto, gostaríamos de
          compartilhar alguns materiais que serviram como referencial teórico
          para o nosso grupo.
        </p>
      </div>
      <Link to='/referencialp'>Acesse aqui</Link>
      <p></p>
    </div>
  );
}
export default Referencial;
